<div class="item" (click)="openProfile($event)">
  <img *ngIf="imgAvatar"  class="item-user-avatar"  
    [src]="imgAvatar" 
    [class.signed]="checkedState"
    [style.width]="avatarSize"   [style.height]="avatarSize">
  <p *ngIf="genericAvatar" class="item-user-avatar generic" [class.signed]="checkedState"
    [style.background]="genericAvatar.background"  
    [style.width]="avatarSize"   
    [style.height]="avatarSize"
    [style.font-size]="fontSize + 'px'"
    >
    {{genericAvatar.text}}
  </p>
  <img class="item-user-avatar-status" *ngIf="checkedState"
  [src]="'../../../../../assets/icons/checkbox-circle-fill.svg'"
  >
</div>